import React from "react";
import Select from "react-select";

const counties = [
  { value: "Alba", label: "Alba" },
  { value: "Arad", label: "Arad" },
  { value: "Argeș", label: "Argeș" },
  { value: "Bacău", label: "Bacău" },
  { value: "Bihor", label: "Bihor" },
  { value: "Bistrița-Năsăud", label: "Bistrița-Năsăud" },
  { value: "Botoșani", label: "Botoșani" },
  { value: "Brașov", label: "Brașov" },
  { value: "Brăila", label: "Brăila" },
  { value: "București", label: "București" },
  { value: "Buzău", label: "Buzău" },
  { value: "Caraș-Severin", label: "Caraș-Severin" },
  { value: "Călărași", label: "Călărași" },
  { value: "Cluj", label: "Cluj" },
  { value: "Constanța", label: "Constanța" },
  { value: "Covasna", label: "Covasna" },
  { value: "Dâmbovița", label: "Dâmbovița" },
  { value: "Dolj", label: "Dolj" },
  { value: "Galați", label: "Galați" },
  { value: "Giurgiu", label: "Giurgiu" },
  { value: "Gorj", label: "Gorj" },
  { value: "Harghita", label: "Harghita" },
  { value: "Hunedoara", label: "Hunedoara" },
  { value: "Ialomița", label: "Ialomița" },
  { value: "Iași", label: "Iași" },
  { value: "Ilfov", label: "Ilfov" },
  { value: "Maramureș", label: "Maramureș" },
  { value: "Mehedinți", label: "Mehedinți" },
  { value: "Mureș", label: "Mureș" },
  { value: "Neamț", label: "Neamț" },
  { value: "Olt", label: "Olt" },
  { value: "Prahova", label: "Prahova" },
  { value: "Satu Mare", label: "Satu Mare" },
  { value: "Sălaj", label: "Sălaj" },
  { value: "Sibiu", label: "Sibiu" },
  { value: "Suceava", label: "Suceava" },
  { value: "Teleorman", label: "Teleorman" },
  { value: "Timiș", label: "Timiș" },
  { value: "Tulcea", label: "Tulcea" },
  { value: "Vaslui", label: "Vaslui" },
  { value: "Vâlcea", label: "Vâlcea" },
  { value: "Vrancea", label: "Vrancea" },
];

const DropdownWithSearch = ({ userCity, setUserCity }) => {
  const handleChange = (selectedOption) => {
    setUserCity(selectedOption ? selectedOption.value : "");
  };
  const customFilter = (option, inputValue) => {
    const label = option.label.toLowerCase();
    const input = inputValue.toLowerCase();

    // Afișează toate opțiunile care încep cu inputul introdus
    return label.startsWith(input);
  };


  return (
    <div className="county-select">
      <Select
        options={counties}
        placeholder="Selectează județul"
        value={counties.find((county) => county.value === userCity) || null}
        onChange={handleChange}
        isClearable
        required
        aria-label="Județ"
        classNamePrefix="county-select"
        filterOption={customFilter}
        noOptionsMessage={() => "Nu am găsit județul"}
        styles={{
          control: (provided, state) => ({
            ...provided,
            width: "100%",
            minHeight: "52px",
            padding: 0,
            border: `1.5px solid ${state.isFocused ? "#904d71" : "rgba(144, 77, 113, 0.18)"}`,
            borderRadius: "14px",
            background: "#ffffff",
            boxShadow: state.isFocused ? "0 0 0 4px rgba(144, 77, 113, 0.10)" : "none",
            fontFamily: "'Montserrat', sans-serif",
            transition: "border-color 0.2s ease, box-shadow 0.2s ease",
            "&:hover": {
              borderColor: "#904d71",
            },
          }),
          valueContainer: (provided) => ({
            ...provided,
            minHeight: "50px",
            padding: "0 16px",
            display: "flex",
            alignItems: "center",
          }),
          input: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
            color: "#4f4349",
          }),
          placeholder: (provided) => ({
            ...provided,
            margin: 0,
            fontSize: "15px",
            lineHeight: 1.2,
            color: "#776b71",
            opacity: 0.6,
          }),
          singleValue: (provided) => ({
            ...provided,
            margin: 0,
            fontSize: "15px",
            lineHeight: 1.2,
            color: "#4f4349",
          }),
          indicatorsContainer: (provided) => ({
            ...provided,
            minHeight: "50px",
            alignItems: "center",
          }),
          indicatorSeparator: (provided) => ({
            ...provided,
            alignSelf: "center",
            width: "1px",
            height: "18px",
            margin: 0,
            backgroundColor: "rgba(144, 77, 113, 0.22)",
          }),
          dropdownIndicator: (provided, state) => ({
            ...provided,
            padding: "0 12px",
            color: state.isFocused ? "#6c3d51" : "#904d71",
            "&:hover": { color: "#6c3d51" },
          }),
          clearIndicator: (provided) => ({
            ...provided,
            padding: "0 8px",
            color: "#776b71",
            "&:hover": { color: "#904d71" },
          }),
          menu: (provided) => ({
            ...provided,
            zIndex: 20,
            overflow: "hidden",
            marginTop: "8px",
            border: "1px solid rgba(144, 77, 113, 0.14)",
            borderRadius: "14px",
            background: "#ffffff",
            boxShadow: "0 18px 44px -22px rgba(42, 31, 37, 0.42)",
          }),
          menuList: (provided) => ({
            ...provided,
            padding: "6px",
          }),
          option: (provided, state) => ({
            ...provided,
            padding: "10px 12px",
            borderRadius: "10px",
            backgroundColor: state.isSelected
              ? "#904d71"
              : state.isFocused
                ? "#fdf2f8"
                : "#ffffff",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "14px",
            color: state.isSelected ? "#ffffff" : "#4f4349",
            cursor: "pointer",
            "&:active": {
              backgroundColor: state.isSelected ? "#6c3d51" : "#fdf2f8",
            },
          }),
        }}
      />
    </div>
  );
};

export default DropdownWithSearch;
